import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from 'src/app/modules/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { CryptoService } from 'src/app/pages/core/abstraction/crypto.service';
import { ICharge, CHARGE_STATUS_TEXT } from 'src/app/pages/core/models/Commerce';
import { ChargeConfirmComponent } from '../charge-form/charge-confirm/charge-confirm.component';

@Component({
  selector: 'app-charge-info-dialog',
  templateUrl: './charge-info-dialog.component.html',
  styleUrls: ['./charge-info-dialog.component.scss'],
})
export class ChargeInfoDialogComponent implements OnInit {
  charge: ICharge;
  statusText = CHARGE_STATUS_TEXT;
  successCopy = false;
  successCopyUrl = false;
  constructor(
    public dialogRef: MatDialogRef<ChargeConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { chargeId: string; isFromPayment: boolean },
    public cryptoSvc: CryptoService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    if (this.data.isFromPayment) {
      this.cryptoSvc.getCharge(this.data.chargeId).subscribe((chargeFound) => {
        if (chargeFound) this.charge = chargeFound;
      });
    } else {
      this.cryptoSvc.getCharges().subscribe(({ result }) => {
        if (result) {
          this.charge = result.charges.find((charge) => charge.id === this.data.chargeId);
          if (this.charge) {
            this.charge.payments = this.charge.payments.filter((payment) => {
              return payment.status === 'confirmed';
            });
          }
        }
      });
    }
  }

  async copyChargeId() {
    await window.navigator.clipboard.writeText(this.charge.id);
    this.successCopy = true;
    setTimeout(() => {
      this.successCopy = false;
    }, 3000);
  }

  async resolveCharge() {
    this.dialog
      .open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'Resolver cargo',
          content: `Estás por marcar el cargo como resuelto. Una vez lo hagas, el pago será dado como exitoso y se te acreditará el monto de criptomonedas que el usuario haya enviado`,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.dialogRef.close();
          this.cryptoSvc.resolveCharge(this.charge.id).subscribe();
        }
      });
  }

  async refundCharge() {
    this.dialog
      .open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'Reembolsar cargo',
          content: `Estás por reembolsar el cargo`,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.dialogRef.close();
          this.cryptoSvc.refundCharge(this.charge.id).subscribe();
        }
      });
  }

  openChargeUrl() {
    window.open(this.charge.hosted_url);
  }

  copyUrl() {
    this.successCopyUrl = true;
    window.navigator.clipboard.writeText(this.charge.hosted_url);
    setTimeout(() => {
      this.successCopyUrl = false;
    }, 1000);
  }
}
